import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute: React.FC = () => {
  // Get user data from localStorage
  const userData = localStorage.getItem("user-data");
  const user = userData ? JSON.parse(userData) : null;

  // If not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Otherwise, allow access to protected routes
  return <Outlet />;
};

export default ProtectedRoute;